import React, {
	memo,
	useEffect,
	useState
} from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Tab } from 'semantic-ui-react';

import { log } from '../../../../../../services/utils';

import ProgramsTable from './ProgramsTable';
import ProgramDetails from './ProgramDetails';

const ProgramsTab = ( {
	activeIndex,
	hideMenu
} ) => {
	const { state: navigationState } = useLocation();

	const [ program, setProgram ] = useState( navigationState
		? navigationState.program
		: null );

	useEffect( () => {
		if ( program ) {
			hideMenu( true );
		} else {
			hideMenu( false );
		}
	}, [
		hideMenu,
		program
	] );

	return (
		<Tab.Pane as="div">
			{ log( 'programsTab' ) }
			{ program
				? <ProgramDetails
					activeIndex={ activeIndex }
					program={ program }
					setProgram={ setProgram }
				/>
				: <ProgramsTable setProgram={ setProgram } />
			}
		</Tab.Pane>
	);
};

ProgramsTab.propTypes = {
	activeIndex: PropTypes.number,
	hideMenu: PropTypes.func
};

export default memo( ProgramsTab );
